import { forwardRef } from 'react'

import { IPortIconTemplate } from '../../../template/iport-icon-template'
import { IconProps } from '../../../types/types'

export const CheckCircleSvg = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
	return (
		<IPortIconTemplate ref={ref} {...props}>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="#568DFE"
			/>
			<path
				d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
				fill="url(#paint0_linear_15447_51738)"
			/>
			<g clipPath="url(#clip0_15447_51738)">
				<path
					d="M17 9L10.3658 16L7 12.6339"
					stroke="white"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_15447_51738"
					x1="22.35"
					y1="22.6364"
					x2="3"
					y2="13.3846"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#E4EDFC" />
					<stop offset="1" stopColor="#568DFE" />
				</linearGradient>
				<clipPath id="clip0_15447_51738">
					<rect width="12" height="9" fill="white" transform="translate(6 8)" />
				</clipPath>
			</defs>
		</IPortIconTemplate>
	)
})
